import styled from "styled-components";
import { NavbarBrand, Navbar, NavItem } from "reactstrap";


export const FullNavbar = styled(Navbar)`
    padding:0rem 2.5rem;
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    background: #fff;
    z-index: 1030;
    border-bottom: 1px solid #8cc63f;
    @media only screen and (max-width:991px){
        background-color: rgb(255, 255, 255);
        box-shadow: 0 1px 5px rgba(0, 0, 0, 0.05), 0 1px 4px rgba(0, 0, 0, 0.10);
        z-index: 1030;
        padding:1rem 1rem;
        position: relative;
    }
    .mobile-show{
        display:none;
        @media only screen and (max-width:991px){
            display: flex;
            justify-content: center;
            margin: 20px 0px;
        }
    }
    .navbar-brand{
        display:block;
        @media only screen and (max-width:991px){
            display:none;
        }
    }
    .navbar-toggler{
        @media only screen and (max-width:991px){
            background-color: transparent;
            border-radius: 50%;
            margin-top: 0;
            margin-bottom: 0;
            margin-right: 0;
            width: 40px;
            height: 40px;
            padding: 0;
            border: none;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-left: auto;
            margin-right: 20px;
            margin-top: 15px;
            margin-bottom: 15px;
        }
        svg{
            color:#fff;
            font-size: 30px;
        }
        &:focus{
            outline:none;
        }
    }
    .show.navbar-collapse{
        background: #fff;
    }
`;
export const NavbarLogo = styled(NavbarBrand)`
    img{
        max-width: 260px;
        margin: 18px 0px;
        @media only screen and (min-width:1200px) and (max-width:1400px){
            max-width: 200px;
        }
        @media only screen and (max-width:991px){
            display: block;
            margin: 18px auto;
        }
    }
`;

export const LeftWrap = styled.div`
    flex: 1;
    height:120px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 0px 45px;
    @media only screen and (min-width:1200px) and (max-width:1400px){
        padding: 0px 10px;
    }
    @media only screen and (max-width:991px){
        padding: 0px 0px;
        height:unset;
    }
    .navbar-brand{
        display:none;
        @media only screen and (max-width:991px){
            display:block;
            padding:0px;
        }
    }
`;
export const TopWrap = styled.div`
    display: flex;
    align-items: center;
    top: 15px;
    position: relative;
    @media only screen and (max-width:1400px){
        margin-left:16px;
    }
    @media only screen and (min-width:991px) and (max-width:1091px){
        top: 10px;
    }
    @media only screen and (max-width:991px){
        top: 0px;
    }
    ul{
        @media only screen and (max-width:991px){
            width:100%;
            display: flex;
            justify-content:center;
            flex-direction: row;
        }
    }
    @media only screen and (max-width:400px){
        .PatientLink {
            margin-right: 0 !important;
        }
    }
    a{
        position: relative;
        margin-right: 40px;
        color: #474f56;
        padding: 10px 25px !important;
        @media only screen and (max-width:1600px){
            margin-right: 2px;
        }
        @media only screen and (min-width:1200px) and (max-width:1450px){
            margin-right: 5px;
            padding: 10px 15px !important;
        }
        @media only screen and (max-width:991px){
            margin-right: 25px;
            padding: 0px 0px !important;
            font-size: 14px !important;
        }
        @media only screen and (max-width:400px){
            margin-right:14px;
            font-size: 13px !important; 
        }
        @media only screen and (max-width:320px){
            margin-right:12px;
            font-size: 12px !important; 
     }
    .active a{
        &:after {
            content: "";
            position: absolute;
            left: 0px;
            right: 0px;
            bottom: 0px;
            height: 3px;
            background-color: #aad27c;
        }
    } 
 
`;

export const ContactButton = styled.button`
    border: 2px solid #8cc63f;
    border-radius: 5px;
    font-size: 14px;
    background-color: transparent;
    color: #474f56;
    padding: 0 30px;
    height: 30px;
    line-height: 28px;
    text-transform: uppercase;
    margin-right:15px;
    transition: 0.3s;
    &:hover{
        background-color: rgba(140, 198, 63, 0.7);
        color: #ffffff;
    }
    @media only screen and (max-width:1600px){
        padding: 2px 10px;
        line-height: 20px;
    }
`;

export const TopRightWrap = styled.div`
    list-style-type: none;
    display: flex;
    align-items: center;
    a{
        margin-right: 0px !important;
        font-weight:500 !important;
    }
    @media only screen and (max-width:1200px){
        display:none;
    }
`;
export const WebNone = styled.div`
    display: none;
    @media only screen and (max-width:991px){
        display: block;
        padding-top: 17px;
    }
`;


export const IconsWrap = styled.div`
    display: flex;
    align-items: center;
`;

export const BottomWrap = styled.div`
    @media only screen and (max-width:991px){
        margin: 0px -16px;
        margin-bottom: -16px;
        background: #91959A;
    }   
    .dropdown {
        padding: 11px 20px;
        color: #474f56 !important;
        transition: 0.3s;
        border-right: 1px solid lightgray;
        @media only screen and (min-width:991px) and (max-width:1091px){
            padding: 11px 10px;
        }
        &:hover{
            background: #8cc63f;
            color: #ffffff !important;
            @media only screen and (max-width:991px){
                color: #474f56 !important;
                background: transparent;
            }
        }
        .dropdown-menu.show{
            @media only screen and (max-width:991px){
                background: #8cc63f;
            color: #ffffff !important;
            }
        }
        .dropdown-toggle::after{
            margin-left: 15px;
            margin-bottom: -2px;
            @media only screen and (max-width:991px){
                position: absolute;
                right: 20px;
                top: 12px;
            }
        }
        @media only screen and (max-width:991px){
            border:none;
            border-bottom: 1px solid #474f56;
            padding: 20px 0px;
        }
    }
    ul{
        @media only screen and (max-width:991px){
            padding:0px 15px;
        }
    }
    li a{
        font-size: 15px !important;
        color: unset !important;
        font-weight: 600;
        padding: 0px;
        @media only screen and (max-width:991px){
            position: relative;
        }
    }
    .navbar-nav .dropdown-menu{
        left:0px;
        border:none;
        border-radius:0px;
        margin: 0px;
        padding: 0px;
        transition: all .5s;
        width: 100%;
        min-width: unset;
    }
    .show {
        background: #8cc63f;
        color: #ffffff !important;
        @media only screen and (max-width:991px){
            color: #474f56 !important;
            background: transparent;
        }
    }
    .dropdown-item{
        padding: 15px;
        white-space: pre-wrap;
        color: #fff;
        text-align: center;
        border-bottom: 1px solid #fff;
        transition: 0.3s;
        font-size: 15px;
        &:hover{
            background: #474f56;
            color: #ffffff;
        }
    }
`;
export const IconItem = styled.div`
    a{
        padding: 0px 5px !important;
    }
    svg{
        color:#91959a;
        font-size: 18px;
    }
`;

export const MobileLocation = styled.div`
    display:none;
    @media only screen and (max-width:991px){
        display:block;
        margin-left:auto;
        border: 1px solid rgba(0, 0, 0, .1);
        border-radius: 50%;
        width: 40px;
        height: 40px;
        padding: .45rem;
        color: rgba(249, 181, 196, 1.00);
        transition: all 400ms cubic-bezier(0.445, 0.5, 0.55, 0.95);
        margin-right:1rem;
    }
    svg{
        color: rgba(249, 181, 196, 1.00) !important;
        font-size:14px;
    }
`;

export const NavItems = styled(NavItem)`
    a{
        font-weight:600;
        font-style: normal;
        font-size: 14px;
        color: #474f56 !important;
        transition-duration: 0.3s;
        @media only screen and (min-width:992px) and (max-width:1100px) {
            font-size: .8rem;
        }
        @media only screen and (max-width:991px){
            font-size: 1rem;
            padding-top: 1rem;
            padding-bottom: 1rem;
                color: #474f56;
            text-align:left;
        }
        &:hover{
            color: #8cc63f !important;
            text-decoration: none;
        }
    }
    .mobile-button{
        @media only screen and (max-width:991px){
            background: transparent;
            border: 1px solid rgba(0, 0, 0, .1);
            transition: all 400ms cubic-bezier(0.445, 0.5, 0.55, 0.95);
            color: rgba(164, 164, 164, 1.00);
            padding: .5rem;
            border-radius: 50rem;
            font-weight: 400;
            font-size: 1rem;
            line-height: 1.5;
            text-align:center;
            margin-bottom: 1rem;
        }
    }
`;
export const FindButton = styled.a`
background: transparent;
border: 1px solid rgba(0, 0, 0, .1);
transition: all 400ms cubic-bezier(0.445, 0.5, 0.55, 0.95);
padding:.5rem 1.5rem;
border-radius: 50rem!important;
font-size: 1rem;
color: rgba(0,0,0,.5) !important;
line-height: 1.5;
display: flex;
    align-items: center;
    justify-content: center;
    @media only screen and (min-width:992px) and (max-width:1100px) {
        font-size: .8rem;
        padding: .5rem 1rem;
    }
@media only screen and (max-width:991px){
    display:none;
}
&:hover{
    border: 1px solid #8cc63f !important;
    text-decoration: none;
}

svg{
    color: #8cc63f !important;
    margin-right:.5rem;
    font-size:14px;
}
`;



// WEBPACK FOOTER //
// ./src/component/Header/styles.js